module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks_Student-Testimonial_Clarissa-Teh_Poster-9fea06b21ce1ff1e62d438a1d5b3f5aa.jpg";